import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribeMsg, setSubscribeMsg] = useState("");

  const handleSubscribe = () => {
    if (!email.trim()) {
      setSubscribeMsg("Please enter your email address.");
      return;
    }

    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!valid) {
      setSubscribeMsg("Please enter a valid email address.");
      return;
    }

    setSubscribeMsg("Thanks for subscribing!");
    setEmail("");
  };

  const handleLinkClick = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {}

        <div className="footer-col brand-info">
          <div className="footer-logo-bg">
            <img src="/logo.png" alt="Sahara Logo" className="footer-logo" />
          </div>

          <div className="brand-text">
            <p>Sahara Public Secondary School</p>

            <p>Nurturing Excellence, Building Character</p>

            <p>CBSE Affiliation Number : 500430003</p>
          </div>

          <hr className="footer-divider" />

          <div className="newsletter">
            <div className="footer-subscribe-btn">
              <input
                type="email"

                placeholder="Your Email"

                value={email}

                onChange={(e) => setEmail(e.target.value)}
              />

              <button onClick={handleSubscribe}>Subscribe &gt;</button>
            </div>

            {subscribeMsg && <p className="subscribe-msg">{subscribeMsg}</p>}
          </div>
        </div>

        {}

        <div className="footer-col">
          <div className="footer-section">
            <h4 className="col-title">ABOUT</h4>

            <ul>
              <li>
                <Link to="/vision-mission" onClick={handleLinkClick}>
                  Our Vision
                </Link>
              </li>

              <li>
                <Link to="/about#principal" onClick={handleLinkClick}>
                  Principal's Message
                </Link>
              </li>

              <li>
                <Link to="/history-milestone" onClick={handleLinkClick}>
                  History & Milestone
                </Link>
              </li>

              <li>
                <Link to="/management-team" onClick={handleLinkClick}>
                  Sahara Management
                </Link>
              </li>

              <li>
                <Link to="/about#board-advisors" onClick={handleLinkClick}>
                  Board of Advisors
                </Link>
              </li>

              <li>
                <Link to="/school-campus" onClick={handleLinkClick}>
                  Sahara Schools Group
                </Link>
              </li>

              <li>
                <Link to="/career" onClick={handleLinkClick}>
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="col-title yellow-text">SCHOOL LEVELS</h4>

            <ul>
              <li>
                <Link to="/Pre-Primary" onClick={handleLinkClick}>
                  Pre-Primary
                </Link>
              </li>

              <li>
                <Link to="/Primary-school" onClick={handleLinkClick}>
                  Primary School
                </Link>
              </li>

              <li>
                <Link to="/Secondary-school" onClick={handleLinkClick}>
                  Secondary School
                </Link>
              </li>

              <li>
                <Link to="/High-school" onClick={handleLinkClick}>
                  High School
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {}

        <div className="footer-col">
          <div className="footer-section">
            <h4 className="col-title light-green">CURRICULA</h4>

            <ul>
              <li>
                <Link to="/primarycurricula" onClick={handleLinkClick}>
                  Primary Curriculum
                </Link>
              </li>

              <li>
                <Link to="/seeb" onClick={handleLinkClick}>
                  SEEB
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="col-title yellow-text">ADMISSIONS</h4>

            <ul>
              <li>
                <Link to="/admission-process" onClick={handleLinkClick}>
                  Admission Process
                </Link>
              </li>

              <li>
                <Link to="/feestructure" onClick={handleLinkClick}>
                  Fee Structure
                </Link>
              </li>

              <li>
                <Link to="/admissionenquiryform" onClick={handleLinkClick}>
                  Admission Form
                </Link>
              </li>
              <li>
                <Link to="/scholarship" onClick={handleLinkClick}>
                  Scholarships
                </Link>
              </li>

              <li>
                <Link to="/book-meeting" onClick={handleLinkClick}>
                  Book a Meeting
                </Link>
              </li>

              <li>
                <Link to="/contact" onClick={handleLinkClick}>
                  Enquiry Form
                </Link>
              </li>
              <li>
                <Link to="/upcoming-events" onClick={handleLinkClick}>
                  Upcoming Events
                </Link>
              </li>
              <li>
                <Link to="/transfer-certificate" onClick={handleLinkClick}>
                  Transfer Certificate
                </Link>
              </li>
              <li>
                <Link to="/publicvsprivate" onClick={handleLinkClick}>
                  Public vs. Private
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}

        <div className="footer-col">
          <div className="footer-section">
            <h4 className="col-title light-green">STUDENT LIFE</h4>

            <ul>
              <li>
                <Link to="/school-gems" onClick={handleLinkClick}>
                  Holistic Education Framework
                </Link>
              </li>

              <li>
                <Link to="/facilitiespage" onClick={handleLinkClick}>
                  Facilities
                </Link>
              </li>

              <li>
                <Link to="/eca" onClick={handleLinkClick}>
                  Extra Curricular Activities
                </Link>
              </li>

              <li>
                <Link to="/co-curricular" onClick={handleLinkClick}>
                  Co Curricular
                </Link>
              </li>

              <li>
                <Link to="/events&activities" onClick={handleLinkClick}>
                  Events & Activities
                </Link>
              </li>

              <li>
                <Link to="/parent-engagement" onClick={handleLinkClick}>
                  Parents Engagement
                </Link>
              </li>

              <li>
                <Link to="/happiness-index" onClick={handleLinkClick}>
                  Happiness Index
                </Link>
              </li>

              <li>
                <Link to="/safety-security" onClick={handleLinkClick}>
                  Safety & Security
                </Link>
              </li>

              <li>
                <Link to="/University-Placement" onClick={handleLinkClick}>
                  University Placement
                </Link>
              </li>

              <li>
                <Link to="/faculty" onClick={handleLinkClick}>
                  Faculty
                </Link>
              </li>

              <li>
                <Link to="/ValueAddedProgrammes" onClick={handleLinkClick}>
                  Value Added Programmes
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="col-title yellow-text">FINANCIAL</h4>

            <ul>
              <li>
                <Link
                  to="/fund-raising"
                  onClick={handleLinkClick}
                  className="donate-btn"
                >
                  Donate Now
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {}

        <div className="footer-col">
          <div className="footer-section">
            <h4 className="col-title light-green">RESOURCES</h4>

            <ul>
              <li>
                <Link to="/resources" onClick={handleLinkClick}>
                  Resources
                </Link>
              </li>

              <li>
                <Link to="/recent-blogs" onClick={handleLinkClick}>
                  Blog
                </Link>
              </li>

              <li>
                <Link to="/resources" onClick={handleLinkClick}>
                  Podcast
                </Link>
              </li>

              <li>
                <Link to="/resources#campus-news" onClick={handleLinkClick}>
                  Sahara Campus
                </Link>
              </li>

              <li>
                <Link to="/featured-blogs" onClick={handleLinkClick}>
                  Publication
                </Link>
              </li>

              <li>
                <Link to="/photos" onClick={handleLinkClick}>
                  Photos
                </Link>
              </li>

              <li>
                <Link to="/videos" onClick={handleLinkClick}>
                  Videos
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <ul>
              <li>
                <Link
                  to="/poll"

                  onClick={handleLinkClick}

                  style={{
                    fontWeight: "bold",
                    color: "#ffcc00",
                  }}
                >
                  VOTE BEST SCHOOL
                </Link>
              </li>

              <li>
                <Link
                  to="/sitemap"

                  onClick={handleLinkClick}
                >
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {}

      <div className="footer-copyright-bar">
        <div className="copyright-content">
          <span>
            © 2026 Sahara Public Secondary School. All Rights Reserved.
          </span>

          <span className="separator">|</span>

          <div className="copyright-links">
            <Link to="/privacy-policy" onClick={handleLinkClick}>
              Privacy Policy
            </Link>

            <Link to="/TermsOfService" onClick={handleLinkClick}>
              Terms & Conditions
            </Link>

            <Link to="/sitemap" onClick={handleLinkClick}>
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
